<template>
  <v-dialog v-model="dialog" transition="dialog-top-transition" max-width="600">
    <template v-slot:default="dialog">
      <v-card>
        <v-toolbar color="blue" class="darken-4" dark>Recepcion de Paquete</v-toolbar>
        <v-card-text>
          <v-container class="mt-1" v-if="!loading">
            <v-select
              v-model="item.tipoDocumentoSector"
              :items="docssector"
              label="Documento Sector:"
              :disabled="loading"
              item-value="id"
              class="mt-4"
              outlined
              dense
              hide-details
            />
          </v-container>
          <!-- <p class="mb-0"><b>Documento sector: </b> {{ item.tipoDocumentoSector }}</p> -->

          <v-progress-linear class="mt-4" indeterminate v-if="loading" />
          <p class="text-center red--text">{{ msg }}</p>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn text @click="registrar()" class="green" dark>Emitir paquete</v-btn>
          <v-btn text @click="dialog.value = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </template>
  </v-dialog>
</template>

<script>
  import xaxios from '@/xaxios';
  export default {
    data() {
      return {
        dialog: false,
        loading: false,
        loadingtipoDocumentoSector: false,
        msg: '',
        tdocs: [],
        docssector: [
          { id: 1, text: 'COMPRA Y VENTA' },
          { id: 11, text: 'SECTOR EDUCATIVO' },
        ],
        item: {
          cafc: 'string',
          eventoID: 0,
          tipoDocumentoSector: null,
        },
        xapikey: null,
      };
    },
    components: {},
    watch: {
      'item.tipoDocumentoSector': function() {
        if (!this.item.tipoDocumentoSector) return;
        this.verificarCafcActivo(this.item.tipoDocumentoSector);
      },
    },
    methods: {
      openmodal(item, xapikey) {
        window.console.log(item, xapikey);
        this.xapikey = xapikey;
        this.msg = '';
        this.dialog = true;
        this.loading = false;
        this.item.eventoID = item.id;
        this.item.cafc = 'string';
        this.item.tipoDocumentoSector = null;
        window.console.log(item);
        this.getdocumentos();
      },
      getdocumentos() {
        //this.tdocs.push({codigo:1,text:""});
        let vue = this;
        this.loadingtipoDocumentoSector = true;
        var config = {
          method: 'get',
          url: `${process.env.VUE_APP_FACT_REST}/facturacion/catalogo/documentosector`,
          headers: {
            'Content-Type': 'application/json',
            // apikey: this.$store.getters.getApiKey,
            apikey: this.xapikey ? this.xapikey : this.$store.getters.getApiKey,
          },
        };

        xaxios.request(config)
          .then(function(response) {
            let data = response.data;
            data.forEach((e) => {
              e.text = `${e.codigoActividad} (${e.descripcion})`;
            });
            vue.tdocs = data;
            vue.loadingtipoDocumentoSector = false;
          })
          .catch(function(error) {
            window.console.log(error);
            vue.loadingtipoDocumentoSector = false;
          });
      },
      verificarCafcActivo(numeroDocumentoSector) {
        //window.console.log('xapikey:::', this.xapikey);
        let vue = this;
        var config = {
          method: 'get',
          url: `${process.env.VUE_APP_FACT_REST}/facturacion/cafcs/buscarActivo/${numeroDocumentoSector}`,
          headers: {
            // apikey: this.$store.getters.getApiKey,
            apikey: this.xapikey ? this.xapikey : this.$store.getters.getApiKey,
            'Content-Type': 'application/json',
          },
        };

        xaxios.request(config)
          .then(function(response) {
            let data = response.data;
            window.console.log('verificarCafcActivo:', data);
            vue.item.cafc = data.codigo;
          })
          .catch(function(error) {
            window.console.log(error);
          });
      },
      registrar() {
        this.msg = '';
        if (!this.item.tipoDocumentoSector) {
          this.msg = 'Seleccione un tipo documento sector.';
          return;
        }
        let vue = this;
        vue.loading = true;
        var config = {
          method: 'post',
          url: `${process.env.VUE_APP_FACT_REST}/facturacion/emision/paquetes/documentosector`,
          headers: {
            // apikey: this.$store.getters.getApiKey,
            apikey: this.xapikey ? this.xapikey : this.$store.getters.getApiKey,
            'Content-Type': 'application/json',
          },
          data: this.item,
        };

        xaxios.request(config)
          .then(function(response) {
            let data = response.data;
            if (data.envio) {
              vue.msg = `Cod. recep: ${data.envio.codigoRecepcion} - ${data.envio.codigodescripcion}`;
            }
            window.console.log('registrar masivo:', data);
            vue.loading = false;
          })
          .catch(function(error) {
            window.console.log(error);
            vue.loading = false;
            let data = error.response.data;
            let mensaje = data.mensaje;
            window.console.log(data);
            if (mensaje || data.detalles) vue.msg = `Error ${mensaje}`;
            else vue.msg = `${data[0].codigo} - ${data[0].descripcion}`;
          });
      },
    },
  };
</script>
